import {StableToChoose} from 'api/gen/StableToChoose';

/**
 * Builds the calf-browser route for a selected stable row.
 *
 * @param row Stable row selected on the overview table.
 * @returns The calf-browser route for the stable's farm.
 */
export const getCalfTableLink = (row: StableToChoose): string => `/animal-browser/calf-browser/${row.farmId}`;
